import React from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

const HomepageIncentives = ({ language }) => {
  return (
    <section
      className="container"
      id="HomepageIncentives"
      aria-label="Homepage Incentives"
    >
      <div className="incentives-title">
        <h2>
          <FormattedMessage
            id="homepage.incentives.title"
            defaultMessage="EV Incentives and Tax Credits"
          />
        </h2>
        <p>
          <FormattedMessage
            id="homepage.incentives.subtitle"
            defaultMessage="Find out how much you could save on an EV."
          />
        </p>
        <Link
          to="/incentives"
          style={{ margin: "12px" }}
          className="btn btn-ae mt-10"
          role="button"
        >
          <FormattedMessage
            id="homepage.incentives.personalizeIncentivesButton"
            defaultMessage="Personalize Incentives"
          />
        </Link>
      </div>

      <zr-consumer-incentives-widget
        lang={language?.toLowerCase() ?? "en"}
      ></zr-consumer-incentives-widget>

      <div className="bottom-cta">
        <p>
          <FormattedMessage
            id="homepage.incentives.cta"
            defaultMessage="Live in an apartment building? Landlords and tenants, <a1>learn more</a1> about our Plug-in Austin EV Charging Station Rebate."
            values={{
              a1: (chunks) => (
                <a href="https://austinenergy.com/green-power/plug-in-austin/workplace-charging" target='_blank' rel="noopener noreferrer" >
                  {chunks}
                </a>
              ),
            }}
          />
        </p>
      </div>
    </section>
  );
};

export default HomepageIncentives;
